import React from 'react';
import Lottie from 'react-lottie';
import * as audioWaveAnimation from 'src/components/Animations/AskAdvisorAIAnimation/AudioWave.json';

/**
 * Small Lottie animation of an audio wave used as an icon
 * next to the "Ask Advisor" menu item in the chart export dropdown.
 */
export const AskAdvisorAIAnimation: React.FC<{ size?: number }> = ({ size = 24 }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: audioWaveAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  };

  // @ts-ignore
  return <Lottie options={defaultOptions} height={size} width={size} isClickToPauseDisabled />;
};

export default AskAdvisorAIAnimation;
